import React, { useRef, useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
    userNameHandler,
    roleHandler,
} from "../../util/local-storage";

import Typography from "@mui/material/Typography";

import { debounce } from "@mui/material/utils";
import {
    getWDFLocationList,
    postWDFChangeLocation,
    postWDFpaid,
    uploadfile,
} from "./utils/api-action";
//import TextareaAutosize from "@mui/base/TextareaAutosize";
import CircularProgress from "@mui/material/CircularProgress";
import { useFormik, Field } from "formik";
import * as Yup from "yup";
import FormHelperText from "@mui/material/FormHelperText";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import img_not_showing from "../../assets/images/image_not_showing.png";

const UpdateSlipModal: React.FC = (props) => {

    const [display, setDisplay] = useState(props);
    const [btnSubmit, setBtnSubmit] = useState(false);

    const [loadingPageFlag, setLoadingPageFlag] = useState(0);
    const [notifyMessage, setNotifyMessage] = useState("");
    const [typeNotify, setTypeNotify] = useState("");
    const [openNotify, setNotify] = useState(false);


    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [NowLocation, setNowLocation] = useState([]);
    const [selectValue, setSelectValue] = useState(searchResults[0] || []);
    const [inputValue, setInputValue] = useState("");
    const [remark, setRemark] = useState("");
    const isGrabOrder = props?.isGrabOrder

    const debouncedHandleInputChange = debounce((value) => {
        handleInputChange(value);
    }, 500); // Adjust the delay time

    const handleInputChange = async (value) => {
        const paramSearch = {
            search: value,
        };
        try {
            setLoading(true);
            // Make your asynchronous API call here using the provided query
            const response = await getWDFLocationList(paramSearch);
            const dataLocationList = (await response?.content?.content) || [];
            setSearchResults(dataLocationList);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error("Error fetching data:", error);
        }
    };

    const handleClose = (event, reason) => {
        if (reason && reason == "escapeKeyDown") {
            setShowFullPreview(false);
        }
        if (reason && reason == "backdropClick" && "escapeKeyDown") {
            return;
        }

        if (props.onClose != null) {
            props.onClose(false);
        }
        setSelectedFile(null);
        setFilePreview(null);
        setDisplay({ ...props, isDisplay: false });
        formik.resetForm();
    };

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleNotify = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setNotify(true);
    };

    const onPassValidate = async (e) => {
        e.preventDefault();
        setBtnSubmit(true);
        setBtnSubmit(true);
        if (!formik.isValid) {
            setNotifyMessage("กรุกรอกข้อมูลให้ครบถ้วน");
            setTypeNotify("error");
            handleNotify();
            setBtnSubmit(false);
            return;
        } else {
            var body = {
                serviceNo: props.orderNo,
                paymentAmt: "",
                source: props.dataOrder?.location_code,
                destination: selectValue[0]?.serviceCode,
            };

            postWDFChangeLocation(body)
                .then(function (response) {
                    if (response?.data?.code == 200) {
                        setNotifyMessage("เปลี่ยนสาขาสำเร็จ");
                        setTypeNotify("success");
                        props.passSearchPossummary();
                        handleNotify();
                        props.onSuccess();
                    } else {
                        setNotifyMessage(response?.data?.description);
                        setTypeNotify("error");
                        handleNotify();
                        setBtnSubmit(false);
                    }
                })
                .catch(function () {
                    setNotifyMessage("เปลี่ยนสาขาไม่สำเร็จ กรุณาลองอีกครั้ง");
                    setTypeNotify("error");
                    handleNotify();
                    setBtnSubmit(false);
                });
        }
    };

    const handleCloseDialog = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setNotify(false);
    };

    useEffect(() => {
        if (props.isDisplay) {
            setLoadingPageFlag(0);
            setDisplay(props);
            setBtnSubmit(false);
        } else {
        }
        if (props.dataOrder) {
            const Location = {
                locationCode: props.dataOrder?.location_code,
                locationDesc: props.dataOrder?.location_desc,
            };
            setNowLocation([Location]);
        }
    }, [props.isDisplay, props]);

    const handletextareachange = (event) => {
        const text = event.target.value;
        setRemark(text);
    };

    const formik = useFormik({
        initialValues: {
            orderNumber:
                props?.dataOrder?.order_status !== "PMT" &&
                    props?.dataOrder?.order_status !== "NEW"
                    ? (props?.orderNo).slice(-4)
                    : "",
            amount:
                props?.dataOrder?.order_status !== "PMT" &&
                    props?.dataOrder?.order_status !== "NEW"
                    ? props?.dataOrder?.amount
                    : "",
            selectedFile: null,
        },
        validationSchema: Yup.object({
            amount: Yup.number()
                .required("กรุณากรอกจำนวนเงิน")
                .min(1, "จำนวนต้องมากกว่า 0")
                .max(9999, "จำนวนต้องไม่เกิน 9999")
                .test("match", "จำนวนเงินไม่ตรงกับออเดอร์", function (value) {
                    return value === props.dataOrder?.amount;
                }),
            orderNumber: Yup.string()
                .required("กรอกรหัสข4ตัวหลังของเลขออเดอร์")
                .matches(
                    new RegExp(`^.*${props.orderNo.slice(-4)}$`),
                    "กรุณากรอกรหัส4ตัวหลังของเลขออเดอร์ให้ถูกต้อง"
                ),
            selectedFile: Yup.mixed()
                .test("fileType", "Invalid file format", async (value) => {
                    if (!value) {
                        return false;
                    }
                    const isValid = await checkFileHeader(value);
                    return isValid;
                })
                .required("กรุณาเลือกไฟล์สลิป .jpg .png .gif .webp"),
        }),
        onSubmit: async (values) => {
            try {
                const response = await uploadfile(values.selectedFile);
                if (response.data?.code === 200) {
                    const sllipUrl = response?.data?.content[0]?.filePath;
                    setBtnSubmit(true);
                    setIsLoading(true);
                    // const body = {
                    //     serviceNo: props.orderNo,
                    //     paymentAmt: values.amount,
                    //     serviceType: "WDF",
                    //     paymentStatus: "PMT",
                    //     slip_img: sllipUrl || "",
                    // };
                    let body;

                    if (isGrabOrder) {
                    body = {
                        serviceNo: props.orderNo,
                        paymentAmt: props.dataOrder?.amount,
                        serviceType: "WDF",
                        paymentStatus: "PMT",   // ✅ ต้องมี
                        slip_img: sllipUrl || "",
                    };
                    } else {
                        body = {
                            serviceNo: props.orderNo,
                            paymentAmt: values.amount,
                            serviceType: "WDF",
                            paymentStatus: "PMT",
                            slip_img: sllipUrl || "",
                        };
                    }


                    try {
                        const postResponse = await postWDFpaid(body);
                        console.log(postResponse.data)
                        if (postResponse.data?.code === 200) {
                            setNotifyMessage("บันทึกข้อมูลสำเร็จ");
                            setTypeNotify("success");
                            handleNotify();
                            setTimeout(() => {
                                setIsLoading(false);
                                props.onSuccess();
                            }, 1500);
                        }
                    } catch (error) {
                        setNotifyMessage("บันทึกข้อมูลไม่สำเร็จ กรุณาลองอีกครั้ง");
                        setTypeNotify("error");
                        handleNotify();
                        setIsLoading(false);
                        setBtnSubmit(false);
                    }
                }
                else {
                    setNotifyMessage(response?.message ? response?.message : "อัพโหลดไม่สำเร็จ กรุณาลองอีกครั้ง");
                    setTypeNotify("error");
                    handleNotify();
                    setIsLoading(false);
                    setBtnSubmit(false);
                }
            } catch (error) {
                setNotifyMessage("อัพโหลดไม่สำเร็จ กรุณาลองอีกครั้ง");
                setTypeNotify("error");
                handleNotify();
                setIsLoading(false);
                setBtnSubmit(false);
            }
        },
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [filePreview, setFilePreview] = useState(null);
    const [showFullPreview, setShowFullPreview] = useState(false);
    // const [unableEdit, setUnableEdit] = useState(
    //     props?.dataOrder?.order_status !== "PMT" &&
    //         props?.dataOrder?.order_status !== "NEW"
    //         ? true
    //         : false
    // );
    const [unableEdit, setUnableEdit] = useState(
    props?.canGrabUpload
        ? false
        : !(
            props?.dataOrder?.order_status === "PMT" ||
            props?.dataOrder?.order_status === "NEW"
        )
);
    const handleThumbnailClick = () => {
        setShowFullPreview(true);
    };

    const handleCloseFullPreview = () => {
        setShowFullPreview(false);
    };



    const checkFileHeader = async (file) => {
        const arrayFile = await file.arrayBuffer();
        const tempFile = new Uint8Array(arrayFile);

        const header = tempFile.slice(0, 4); // Assuming the header length is 4 bytes

        const headerString = header.join(",");

        // Define the headers for different image formats
        const headerJPG = "255,216";
        const headerPNG = "137,80,78,71";
        const headerGif = "71,73,70,56";
        const headerWebp = "82,73,70,70";
        const headerBMP = "66,77";
        const headerTIFF = "73,73,42, ";
        const headerICO = "0,0,1,0";
        const headerSVG = "60,63,120,109,108,32";
        let output = false;

        if (
            headerString.startsWith(headerJPG) ||
            headerString.startsWith(headerPNG) ||
            headerString.startsWith(headerGif) ||
            headerString.startsWith(headerWebp)
        ) {
            output = true;
        }

        return output;
    };

    const handleFileChange = async (event) => {
        const selected = event.target.files[0];
        setSelectedFile(event.target.files[0]);
        setShowFullPreview(false);

        if (selected?.name !== null) {
            const isValidFile = await checkFileHeader(selected);

            if (!isValidFile) {
                setNotifyMessage(
                    "Invalid file format. Please select a valid image file."
                );
                setTypeNotify("error");
                setNotify(true);
                setSelectedFile(null);
                setFilePreview(null);
                formik.setFieldValue("selectedFile", null);
                formik.setFieldTouched("selectedFile", true);
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                formik.setFieldValue("selectedFile", event.target.files[0]);
                formik.setFieldTouched("selectedFile", true);
                setFilePreview(reader.result);
                formik.validateField();
            };
            reader.readAsDataURL(selected);
        } else {
            // setFilePreview(null);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            // Handle error if no file is selected
            return;
        }

        setIsLoading(true);

        try {
            const formData = new FormData();
            formData.append("image", selectedFile);

            // Replace 'p' with the specific parameter value
            const parameterValue = "slip";

            const response = await axios.post(
                `https://wxpstg.laundry-you.com:9081/api/File/upload/${parameterValue}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

        } catch (error) {
            // Handle error
            console.error("Error uploading file:", error);
        }

        setIsLoading(false);
    };

    return (
        <div>
            <Dialog
                open={display.isDisplay}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <form onSubmit={formik.handleSubmit} autoComplete="off">
                    <DialogTitle className="border-b-2">{"ข้อมูลสลิป"}</DialogTitle>
                    <DialogContent className="m-4">
                        <Typography gutterBottom>
                            <div className="mt-10 justify-center items-center">
                                <div className="flex justify-center items-center mb-5">
                                    <div className="pl-2 pr-2 w-1/3">
                                        <label className="font-bold">เลขออเดอร์ : </label>
                                    </div>
                                    <div className="pl-2 pr-2 w-2/3 p-3">
                                        <TextField
                                            autoFocus
                                            disabled={true}
                                            id="orderNumberPrefix"
                                            name="orderNumberPrefix"
                                            value={(props?.orderNo).slice(0, -4)}
                                            // inputProps={{ maxLength: 4 }}
                                            // {...formik.getFieldProps("orderNumber")}
                                            // error={
                                            //   formik.touched.orderNumber &&
                                            //   formik.errors.orderNumber
                                            // }
                                            size="small"
                                            sx={{ width: 155, textAlignLast: "center" }}
                                        />{" "}
                                        <TextField
                                            label="เลขออเดอร์4ตัวท้าย"
                                            disabled={unableEdit}
                                            id="orderNumber"
                                            name="orderNumber"
                                            inputProps={{ maxLength: 4 }}
                                            {...formik.getFieldProps("orderNumber")}
                                            error={
                                                formik.touched.orderNumber && formik.errors.orderNumber
                                            }
                                            size="small"
                                            sx={{ width: 140, textAlignLast: "center" }}
                                        />
                                        <FormHelperText
                                            sx={{
                                                position: "inherit",
                                                bottom: "-20px",
                                                color: "red",
                                            }}
                                        >
                                            {formik.touched.orderNumber && formik.errors.orderNumber}
                                        </FormHelperText>
                                    </div>
                                </div>

                                <div className="flex justify-center items-center mb-5">
                                    <div className="pl-2 pr-2 w-1/3">
                                        <label className="font-bold">จำนวนเเงิน :</label>
                                    </div>
                                    <div className="pl-2 pr-2 w-2/3 mb-3 p-3">
                                        <TextField
                                            disabled={unableEdit}
                                            label="กรอกจำนวนเงิน"
                                            id="amount"
                                            type="number"
                                            name="amount"
                                            inputProps={{ min: 0, max: 9999 }}
                                            {...formik.getFieldProps("amount")}
                                            error={formik.touched.amount && formik.errors.amount}
                                            size="small"
                                            sx={{ width: 300 }}
                                        />
                                        <FormHelperText
                                            sx={{
                                                position: "inherit",
                                                bottom: "-20px",
                                                color: "red",
                                            }}
                                        >
                                            {formik.touched.amount && formik.errors.amount}
                                        </FormHelperText>
                                    </div>
                                </div>

                                <div className="flex justify-center items-center">
                                    <div className="pl-2 pr-2 w-1/3">
                                        <label className="font-bold">สลิป :</label>
                                    </div>
                                    <div className="pl-2 w-2/3 justify-center items-center text-center ">
                                        <div
                                            style={{ width: "300px" }}
                                            className={`${unableEdit ? "cursor-not-allowed" : "pointer"
                                                } rounded-lg mb-3 max-h-200px border border-gray-300 flex flex-col justify-center items-center relative`}
                                        >
                                            <Button
                                                disabled={unableEdit}
                                                startIcon={<CloudUploadIcon />}
                                                variant="contained"
                                                onClick={() =>
                                                    document.getElementById("fileInput").click()
                                                }
                                                className="w-full z-10 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
                                                type="button"
                                            >
                                                {filePreview ? "เปลี่ยนสลิป" : "เลือกสลิป"}
                                            </Button>

                                            <input
                                                accept=".jpg, .jpeg, .png, .webp , .gif"
                                                id="fileInput"
                                                type="file"
                                                style={{ display: "none" }}
                                                onChange={handleFileChange}
                                            />
                                        </div>
                                        <FormHelperText
                                            sx={{
                                                position: "inherit",
                                                bottom: "-20px",
                                                color: "red", // Adjust as needed for positioning
                                            }}
                                        >
                                            {formik.touched.selectedFile &&
                                                formik.errors.selectedFile}
                                        </FormHelperText>
                                        {props?.dataOrder?.slip_img && selectedFile === null && (
                                            <img
                                                style={{ width: "300px", maxWidth: "300px", objectFit: "scale-down" }}
                                                onClick={handleThumbnailClick}
                                                src={
                                                    props?.dataOrder?.slip_img
                                                        ? props?.dataOrder?.slip_img
                                                        : img_not_showing
                                                }
                                                alt="OldSlip"
                                                // onError={({ currentTarget }) => {
                                                //   currentTarget.onerror = null; // prevents looping
                                                //   currentTarget.src=img_not_showing
                                                // }}
                                                className="max-w-xs drop-shadow-xl rounded-lg max-h-80 cursor-pointer "
                                            />
                                        )}

                                        {filePreview ? (
                                            <img
                                                style={{ width: "300px", maxWidth: "300px", objectFit: "scale-down" }}
                                                onClick={handleThumbnailClick}
                                                src={filePreview}
                                                alt="Preview"
                                                className="drop-shadow-xl rounded-lg max-h-80 cursor-pointer"

                                            />
                                        ) : null}

                                    </div>

                                    {showFullPreview &&
                                        props?.dataOrder?.slip_img !== null &&
                                        selectedFile === null && (
                                            <div
                                                onClick={handleCloseFullPreview}
                                                style={{
                                                    position: "fixed",
                                                    top: "0",
                                                    left: "0",
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                    zIndex: "999",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <img
                                                    src={props.dataOrder?.slip_img}
                                                    // src="https://images.unsplash.com/photo-1682687981630-cefe9cd73072?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                                                    alt="Full preview"
                                                    style={{
                                                        maxWidth: "85%",
                                                        maxHeight: "85%",
                                                        cursor: "pointer",
                                                    }}
                                                />
                                            </div>
                                        )}

                                    {showFullPreview && filePreview && (
                                        <div
                                            style={{
                                                position: "fixed",
                                                top: "0",
                                                left: "0",
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                                zIndex: "999",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                            }}
                                            onClick={handleCloseFullPreview}
                                        >
                                            <img
                                                src={filePreview}
                                                alt="Full preview"
                                                style={{
                                                    maxWidth: "75%",
                                                    maxHeight: "75%",
                                                    cursor: "pointer",
                                                }}
                                            // onError={({ currentTarget }) => {
                                            //   currentTarget.onerror = null; // prevents looping
                                            //   currentTarget.src=img_not_showing
                                            // }}
                                            />
                                        </div>
                                    )}

                                </div>
                            </div>
                        </Typography>
                    </DialogContent>
                    <DialogActions className="border-t-2">
                        <Button
                            disabled={isLoading}
                            variant="contained"
                            color="error"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={
                                btnSubmit || unableEdit
                            }
                            type="submit"
                        // onClick={(event) => onSubmit(event)}
                        >
                            {isLoading ? <CircularProgress size={24} /> : "Submit"}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Snackbar
                open={openNotify}
                autoHideDuration={6000}
                onClose={handleCloseDialog}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                key={"top" + "center"}
            >
                <Alert
                    onClose={handleCloseDialog}
                    severity={typeNotify}
                    sx={{ width: "100%" }}
                >
                    {notifyMessage}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default UpdateSlipModal;
